import React, { useRef, useEffect, useState, useContext } from 'react';
import { getSetupColor } from '../utils/LMConstants';
import { AppContext, LMDrawingContext, LMShowEllipseContext } from '../contexts/AppContext';
import { GetCurrentSessionAdjustments } from '../isdlData/sessionData';

 //const TopDown = ({ currentSession, currentSetup, currentShot, forcedScale, forcedOrigin, forceUpdateIndex,sharedUserPoints, onUserPointsChange}) => {
  const TopDown = ({currentSession, currentSetup, currentShot,forcedScale, forcedOrigin, forceUpdateIndex, sharedUserPoints,onUserPointsChange, onSelectShotNumber, }) => {
  const canvasRef = useRef(null);
  const [scale, setScale] = useState(null);
  const [origin, setOrigin] = useState(null);
  const [image, setImage] = useState(null);
  const [initialScale, setInitialScale] = useState(null);
  const [lastMousePos, setLastMousePos] = useState(null);
  const [plottedShots, setPlottedShots] = useState([]);
  const [lastTouchDistance, setLastTouchDistance] = useState(null);

  // NEW: user-added points (Shift+Click to add)
  // each: { pixelX, pixelY, xFeet, zYards }
  const [userPoints, setUserPoints] = useState([]);
  const isControlled = sharedUserPoints !== undefined;
  const points = isControlled ? (sharedUserPoints || []) : userPoints; // render from here

  const { lmDrawing }= useContext(LMDrawingContext);
  const { LMShowEllipse } = useContext(LMShowEllipseContext);

  const maxScale = 5; // 500% max zoom

  const [venueAdjustments, setVenueAdjustments] = useState({});

// Return ShotNumber of the hit shot, or null if none
function hitTestShotAt(imgX, imgY) {
  if (!image || !currentSetup) return null;

  const course_widthYds = 168.0;
  const course_depthYds = 336.0;
  const pxPerYardX = image.width / course_widthYds;
  const pxPerYardY = image.height / course_depthYds;

  // Find the plotted group for the *current* setup
  const group = plottedShots.find(s => s.Id === currentSetup.Id);
  if (!group || !group.Shots || group.Shots.length === 0) return null;

  // We draw dots at radius 3 (image-space px). Allow a little slack for clicking:
  const tolerancePx = 8; // image-space pixels

  let best = { shotNumber: null, dist: Infinity };

  for (const shot of group.Shots) {
    const shotXInYards = shot.x / 3;
    const px = (image.width / 2) + (shotXInYards * pxPerYardX);
    const py = image.height - (shot.z * pxPerYardY);

    const dx = imgX - px;
    const dy = imgY - py;
    const d2 = dx * dx + dy * dy;

    if (d2 <= tolerancePx * tolerancePx && d2 < best.dist) {
      best = { shotNumber: shot.Num, dist: d2 };
    }
  }

  return best.shotNumber ?? null;
}


  useEffect(() => {
   // when session or background changes, load any saved points for that context
   const pts = loadPoints();
   setUserPoints(Array.isArray(pts) ? pts : []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSession?.Id, venueAdjustments?.bgImg]);
  useEffect(() => {
    if (!image) return; // wait until image is ready so keys are stable
    savePoints(userPoints);
  }, [userPoints, image]);

  const getPointsStorageKey = () => {
  const sessId = currentSession?.Id ?? 'no-session';
  const bgId = venueAdjustments?.bgImg ?? 'default-bg';
  return `topdown-userpoints:${sessId}:${bgId}`;
  };

  const loadPoints = () => {
   try {
    const raw = sessionStorage.getItem(getPointsStorageKey());
    return raw ? JSON.parse(raw) : [];
       } catch {
    return [];
    }
   };

  const savePoints = (points) => {
    try {
    sessionStorage.setItem(getPointsStorageKey(), JSON.stringify(points));
    } catch { /* ignore quota errors */ }
    };
  // Load saved state from sessionStorage
  useEffect(() => {
    const savedScale = sessionStorage.getItem('topdown-scale');
    const savedOrigin = sessionStorage.getItem('topdown-origin');

    if(forcedScale){
      setScale(forcedScale);
    }

    if(forcedOrigin){
      setOrigin(forcedOrigin);
    }

    if(!forcedScale && !forcedOrigin){
      if (savedScale && savedOrigin) {
        setScale(parseFloat(savedScale));
        setOrigin(JSON.parse(savedOrigin));
      }
    }

    setVenueAdjustments(GetCurrentSessionAdjustments());
    
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const canvas = canvasRef.current;
      const parent = canvas.parentElement;
      canvas.width = parent.clientWidth;
      canvas.height = parent.clientHeight;

      if (image) {
        const aspectRatio = image.width / image.height;
        const canvasAspectRatio = canvas.width / canvas.height;

        let newInitialScale;
        if (aspectRatio > canvasAspectRatio) {
          newInitialScale = canvas.width / image.width;
        } else {
          newInitialScale = canvas.height / image.height;
        }

        setInitialScale(newInitialScale);

        if (scale === null || origin === null) {
          setScale(newInitialScale);
          const origin = 
          {
            x: (canvas.width - image.width * newInitialScale) / 2 / newInitialScale,
            y: canvas.height / newInitialScale - image.height,
          };
          setOrigin(origin);
        }
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    ParseSessionForShots(venueAdjustments.x, venueAdjustments.z,venueAdjustments.deg);

    return () => window.removeEventListener('resize', handleResize);
  }, [currentSession, currentShot, image, lmDrawing, LMShowEllipse, forceUpdateIndex,venueAdjustments.x,venueAdjustments.z,venueAdjustments.deg]);

  useEffect(() => {
    const canvas = canvasRef.current;

    let imgUrl = "";
    if(venueAdjustments.bgImg){
      imgUrl = venueAdjustments.bgImg;
    }else{
      imgUrl = GetCurrentSessionAdjustments().bgImg;
    }

    const img = new Image();
    img.src = imgUrl;
    img.onload = () => {
      setImage(img);
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    if (image && scale !== null && origin !== null) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.save();
      context.scale(scale, scale);
      context.translate(origin.x, origin.y);
      context.drawImage(image, 0, 0);

      drawPlottedShots(context);
      context.restore();
    }
    
    const handleWheel = (event) => {
      event.preventDefault();

      const mouseX = event.clientX - canvas.getBoundingClientRect().left;
      const mouseY = event.clientY - canvas.getBoundingClientRect().top;

      const mouseCanvasX = (mouseX / scale) - origin.x;
      const mouseCanvasY = (mouseY / scale) - origin.y;

      const zoomFactor = 0.1; // Linear zoom factor
      const newScale = Math.max(initialScale, Math.min(maxScale, scale - zoomFactor * Math.sign(event.deltaY)));

      setScale(newScale);

      if (newScale === initialScale) {
        setOrigin({
          x: (canvas.width - image.width * newScale) / 2 / newScale,
          y: canvas.height / newScale - image.height,
        });
      } else {
        const newOriginX = mouseX / newScale - mouseCanvasX;
        const newOriginY = mouseY / newScale - mouseCanvasY;
        setOrigin(clampOrigin(newOriginX, newOriginY, canvas, image, newScale));
      }

      // Save the state after zoom
      saveState(newScale, origin);
    };

    const handleMouseDown = (event) => {
      if (scale === initialScale) return;

      canvas.style.cursor = 'grabbing';
      setLastMousePos({
        x: event.clientX,
        y: event.clientY,
      });
    };

    const handleMouseMove = (event) => {
      if (scale === initialScale || !lastMousePos) return;

      if (event.buttons === 1) {
        const mouseX = event.clientX;
        const mouseY = event.clientY;

        const dx = (mouseX - lastMousePos.x) / scale;
        const dy = (mouseY - lastMousePos.y) / scale;

        setOrigin((prevOrigin) => {
          const newOriginX = prevOrigin.x + dx;
          const newOriginY = prevOrigin.y + dy;
          return clampOrigin(newOriginX, newOriginY, canvas, image, scale);
        });

        setLastMousePos({ x: mouseX, y: mouseY });
      }
    };

    const handleMouseUp = () => {
      canvas.style.cursor = 'grab';
      setLastMousePos(null);

      // Save the state after panning
      saveState(scale, origin);
    };

    const handleTouchStart = (event) => {
      if (event.touches.length === 1) {
        setLastMousePos({
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        });
      } else if (event.touches.length === 2) {
        setLastTouchDistance(calculateDistance(event.touches));
      }
    };

    const handleTouchMove = (event) => {
      if (event.touches.length === 1 && lastMousePos) {
        // Single finger panning
        const touchX = event.touches[0].clientX;
        const touchY = event.touches[0].clientY;

        const dx = (touchX - lastMousePos.x) / scale;
        const dy = (touchY - lastMousePos.y) / scale;

        setOrigin((prevOrigin) => {
          const newOriginX = prevOrigin.x + dx;
          const newOriginY = prevOrigin.y + dy;
          return clampOrigin(newOriginX, newOriginY, canvas, image, scale);
        });

        setLastMousePos({ x: touchX, y: touchY });
      } else if (event.touches.length === 2) {
        // Pinch zooming with panning
        const newDistance = calculateDistance(event.touches);
        const distanceDelta = newDistance - lastTouchDistance;
        const zoomFactor = distanceDelta / 200; // Adjust this value to control zoom sensitivity
        const newScale = Math.max(initialScale, Math.min(maxScale, scale + zoomFactor));

        // Calculate the midpoint between the two fingers
        const midX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
        const midY = (event.touches[0].clientY + event.touches[1].clientY) / 2;

        // Convert the midpoint to canvas coordinates
        const midCanvasX = (midX / scale) - origin.x;
        const midCanvasY = (midY / scale) - origin.y;

        // Adjust the origin to keep the midpoint stationary during zoom
        const newOriginX = midX / newScale - midCanvasX;
        const newOriginY = midY / newScale - midCanvasY;

        // Calculate panning based on the movement of the midpoint
        const touchCenterX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
        const touchCenterY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
        const dx = (touchCenterX - midX) / scale;
        const dy = (touchCenterY - midY) / scale;

        setScale(newScale);
        setOrigin(clampOrigin(newOriginX + dx, newOriginY + dy, canvas, image, newScale));
        setLastTouchDistance(newDistance);
        setLastMousePos({ x: touchCenterX, y: touchCenterY });
      }
    };

    const handleTouchEnd = () => {
      setLastMousePos(null);
      setLastTouchDistance(null);

      // Save the state after touch interactions
      saveState(scale, origin);
    };

    // --- replace your existing handleClick with this ---
const handleClick = (event) => {
  if (!image || scale == null || origin == null) return;

  const rect = canvas.getBoundingClientRect();
  const mouseX = event.clientX - rect.left;
  const mouseY = event.clientY - rect.top;

  // Canvas → image-space
  const imgX = (mouseX / scale) - origin.x;
  const imgY = (mouseY / scale) - origin.y;

  // Bounds check
  if (imgX < 0 || imgY < 0 || imgX > image.width || imgY > image.height) return;

  // SHIFT => add a user point (your existing logic)
  if (event.shiftKey) {
    const course_widthYds = 168.0;
    const course_depthYds = 336.0;
    const pxPerYardX = image.width / course_widthYds;
    const pxPerYardY = image.height / course_depthYds;

    const xYards = (imgX - (image.width / 2)) / pxPerYardX;
    const zYards = (image.height - imgY) / pxPerYardY;
    const xFeet = xYards * 3;

    const newPoint = { pixelX: imgX, pixelY: imgY, xFeet, zYards };

    const isControlled = typeof sharedUserPoints !== 'undefined';
    if (isControlled && typeof onUserPointsChange === 'function') {
      onUserPointsChange([...(sharedUserPoints || []), newPoint]);
    } else {
      setUserPoints(prev => [...prev, newPoint]);
      // savePoints?.([...userPoints, newPoint]); // if you’re persisting locally
    }
    return;
  }

  // NO SHIFT => try to select an existing shot (current setup only)
  const hitShotNum = hitTestShotAt(imgX, imgY);
  if (hitShotNum != null && typeof onSelectShotNumber === 'function') {
    onSelectShotNumber(hitShotNum);
  }
};


    canvas.addEventListener('wheel', handleWheel, { passive: false });
    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseup', handleMouseUp);
    canvas.addEventListener('touchstart', handleTouchStart);
    canvas.addEventListener('touchmove', handleTouchMove);
    canvas.addEventListener('touchend', handleTouchEnd);
    canvas.addEventListener('click', handleClick);

    return () => {
      canvas.removeEventListener('wheel', handleWheel);
      canvas.removeEventListener('mousedown', handleMouseDown);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseup', handleMouseUp);
      canvas.removeEventListener('touchstart', handleTouchStart);
      canvas.removeEventListener('touchmove', handleTouchMove);
      canvas.removeEventListener('touchend', handleTouchEnd);
      canvas.removeEventListener('click', handleClick);
    };
  }, [
    scale,
    origin,
    image,
    initialScale,
    lastMousePos,
    plottedShots,
    lastTouchDistance,
    currentSetup,
    currentSession,
    currentShot,
    userPoints,
    sharedUserPoints // trigger redraw when points change
  ]);

  const calculateDistance = (touches) => {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const drawPlottedShots = (context) => {
    const canvas = canvasRef.current;

    const courseWidthPixels = image.width;
    const courseHeightPixels = image.height;
    const course_widthYds = 168.0;
    const course_depthYds = 336.0;

    const pxPerYardX = courseWidthPixels / course_widthYds;
    const pxPerYardY = courseHeightPixels / course_depthYds;

    if(!currentSetup){
      // Still draw user points even if no setup
      drawUserPoints(context,points);
      return;
    }

    drawBay(context, pxPerYardX, pxPerYardY, venueAdjustments.x, venueAdjustments.z, venueAdjustments.deg);

    plottedShots.forEach((setup) => {
      context.fillStyle = setup.Color;
      let allPoints = [];
      setup.Shots.forEach((shot) => {
        const shotXInYards = shot.x / 3; // Convert feet to yards
        const shotXPx = (courseWidthPixels / 2) + (shotXInYards * pxPerYardX);
        const shotYPx = (image.height) - (shot.z * pxPerYardY);
        const pixelX = shotXPx;
        const pixelY = shotYPx;

        allPoints.push({ x: pixelX, y: pixelY });
        if (shot.curve && setup.Id === currentSetup.Id) {
          if (currentShot && shot.Num === currentShot.ShotNumber) {
            const traj = ParseCurveFit(shot.curve, venueAdjustments.x, venueAdjustments.z, venueAdjustments.deg);
            drawTrajectory(context, traj, pxPerYardX, pxPerYardY);
          }
        }

        // draw the dot
context.beginPath();
context.arc(pixelX, pixelY, 3, 0, 2 * Math.PI);
context.fill();

// if this is the selected shot, draw a thin white outline ring
const isSelected =
  currentShot &&
  currentSetup &&
  setup.Id === currentSetup.Id &&           // only outline within the active setup
  shot.Num === currentShot.ShotNumber;

if (isSelected) {
  // keep outline ~constant screen thickness regardless of zoom
  const pxLine = Math.max(1, 2 / (scale || 1));
  const ringR = 5; // slightly larger than the filled dot (3)

  // optional: black under-stroke for contrast on bright backgrounds
  context.save();
  context.beginPath();
  context.arc(pixelX, pixelY, ringR, 0, 2 * Math.PI);
  context.lineWidth = Math.max(1, 4 / (scale || 1)); // thicker underlay
  context.strokeStyle = '#000000';
  context.stroke();
  context.restore();

  // white outline on top
  context.save();
  context.beginPath();
  context.arc(pixelX, pixelY, ringR, 0, 2 * Math.PI);
  context.lineWidth = pxLine;
  context.strokeStyle = '#FFFFFF';
  context.stroke();
  context.restore();
}

      });

      if (LMShowEllipse) {
        drawEllipse(context, allPoints, setup.Color);
      }
      // TODO DRAW BAY
    });

    drawTarget(context, pxPerYardX, pxPerYardY, venueAdjustments.x, venueAdjustments.z, venueAdjustments.deg);

    // Draw any user-added points on top
    drawUserPoints(context,points);
  };

  // NEW: draw user points stored in state
  const drawUserPoints = (context, pts) => {
    pts.forEach(p => {
      context.beginPath();
      context.fillStyle = '#00FF00';
      context.arc(p.pixelX, p.pixelY, 4, 0, 2 * Math.PI);
      context.fill();

      // Optional tiny label:
      // context.font = '10px sans-serif';
      // context.fillStyle = '#ffffff';
      // context.fillText(`(${p.xFeet.toFixed(1)}ft, ${p.zYards.toFixed(1)}yd)`, p.pixelX + 6, p.pixelY - 6);
    });
  };

  const drawTrajectory = (context, trajectory, pxPerYardX, pxPerYardY) => {
    context.strokeStyle = '#FFFFFF';
    context.lineWidth = 2;

    context.beginPath();

    trajectory.forEach((point, index) => {
      const pixelX = (image.width / 2) + (point[1]) * pxPerYardX;
      const pixelY = image.height - (point[0] * pxPerYardY);

      if (index === 0) {
        context.moveTo(pixelX, pixelY);
      } else {
        context.lineTo(pixelX, pixelY);
      }
    });

    context.stroke();
  };

  const drawEllipse = (context, points, color) => {

    if(points.length === 0){
      return;
    }

    const ellipseParams = fitEllipse(points);

    context.beginPath();
    context.ellipse(
      ellipseParams.centerX,
      ellipseParams.centerY,
      ellipseParams.width,
      ellipseParams.height,
      ellipseParams.angle,
      0,
      2 * Math.PI
    );
    context.strokeStyle = color;
    context.lineWidth = 0;
    context.fillStyle = color + '40';
    context.fill();
  };

  const fitEllipse = (points) => {
    const x = points.map(p => p.x);
    const y = points.map(p => p.y);

    const xmean = x.reduce((a, b) => a + b) / x.length;
    const ymean = y.reduce((a, b) => a + b) / y.length;

    const xCentered = x.map(xi => xi - xmean);
    const yCentered = y.map(yi => yi - ymean);

    const D1 = xCentered.reduce((sum, xi) => sum + xi * xi, 0);
    const D2 = xCentered.reduce((sum, xi, i) => sum + xi * yCentered[i], 0);
    const D3 = yCentered.reduce((sum, yi) => sum + yi * yi, 0);

    const S1 = D1 + D3;
    const S2 = Math.sqrt((D1 - D3) ** 2 + 4 * D2 ** 2);

    const lambda1 = (S1 + S2) / 2;
    const lambda2 = (S1 - S2) / 2;

    const axisRatio = Math.sqrt(lambda1 / lambda2);
    const angle = 0.5 * Math.atan2(2 * D2, D1 - D3);

    const a = Math.sqrt(2 * lambda1 / x.length);
    const b = a / axisRatio;

    return {
      centerX: xmean,
      centerY: ymean,
      width: a,
      height: b,
      angle: angle
    };
  };

  const drawTarget = (context, pxPerYardX, pxPerYardY, offsetX = 0, offsetZ = 0, rotationAngleDeg = 0) => {
    if (currentSession && currentSession.CurrentTarget) {
      let target = null;
      
      if (!currentShot) {
        target = currentSession.CurrentTarget;
      } else {
        target = currentSession.Targets[currentShot.TargetIndex];
      }
      
      if (target) {
        const targetSize = 20;
        // Convert degrees to radians.
        const theta = rotationAngleDeg * (Math.PI / 180);
        
        // Apply offsets before rotation.
        // Add offsetZ to target.X and offsetX to target.Z (to match your ParseCurveFit logic).
        const preRotY = target.X + offsetX;
        const preRotX = target.Z + offsetZ;
        
        // Rotate around the Z-axis.
        const rotatedX = preRotX * Math.cos(theta) - preRotY * Math.sin(theta);
        const rotatedY = preRotX * Math.sin(theta) + preRotY * Math.cos(theta);
        
        // Map to screen coordinates.
        const posX = (image.width / 2) + rotatedY * pxPerYardX;
        const posY = image.height - rotatedX * pxPerYardY;


        context.fillStyle = "red";
        context.beginPath();
        context.arc(posX, posY, targetSize, 0, 2 * Math.PI);
        context.fill();
        
        context.fillStyle = "white";
        context.beginPath();
        context.arc(posX, posY, (targetSize / 3) * 2, 0, 2 * Math.PI);
        context.fill();
        
        context.fillStyle = "red";
        context.beginPath();
        context.arc(posX, posY, targetSize / 3, 0, 2 * Math.PI);
        context.fill();
      }
    }
  };
  

  const drawBay = (context, pxPerYardX, pxPerYardY, offsetX = 0, offsetZ = 0, rotationAngleDeg = 0) => {
    if (currentSession && currentSession.CurrentBay) {
      const Bay = currentSession.CurrentBay;
      const baySize = 15;
      // Convert degrees to radians.
      const theta = rotationAngleDeg * (Math.PI / 180);
      
      // Apply offsets before rotation.
      const preRotY = Bay.X + offsetX;
      const preRotX = Bay.Z + offsetZ;
      
      // Rotate around the Z-axis.
      const rotatedX = preRotX * Math.cos(theta) - preRotY * Math.sin(theta);
      const rotatedY = preRotX * Math.sin(theta) + preRotY * Math.cos(theta);
      
      // Map to screen coordinates.
      const posX = (image.width / 2) + rotatedY * pxPerYardX;
      const posY = image.height - rotatedX * pxPerYardY;
      
      context.strokeStyle = "#20B2AA";
      context.beginPath();
      context.lineWidth = 8;
      context.arc(posX, posY, baySize, 0, 2 * Math.PI);
      context.stroke();
    }
  };
  

  const clampOrigin = (x, y, canvas, image, scale) => {
    const viewportWidth = canvas.width / scale;
    const viewportHeight = canvas.height / scale;

    const canPanX = image.width > viewportWidth;
    const canPanY = image.height > viewportHeight;

    const maxX = canPanX ? 0 : (canvas.width - image.width * scale) / (2 * scale);
    const maxY = canPanY ? 0 : (canvas.height - image.height * scale) / (2 * scale);
    const minX = canPanX ? canvas.width / scale - image.width : maxX;
    const minY = canPanY ? canvas.height / scale - image.height : maxY;

    return {
      x: Math.max(Math.min(x, maxX), minX),
      y: Math.max(Math.min(y, maxY), minY),
    };
  };

  const ParseSessionForShots = (offsetX,offsetZ,RotateDeg) => {
    let sessionData = [];

    if(currentSession === null || currentSession === undefined){
      setPlottedShots(sessionData);
      return;
    }

    if(currentSession.SessionSetups == null || currentSession.SessionSetups.length === 0){
      setPlottedShots(sessionData);
      return;
    }

    for (let i = 0; i < currentSession.SessionSetups.length; i++) {
      const curSetup = currentSession.SessionSetups[i];

      if (!curSetup.IsChecked) {
        continue;
      }

      // if(curSetup.Id !== currentSetup.Id)
      //   continue;

      let shotData = [];

      if(curSetup.Shots == null || curSetup.Shots.length === 0){
        continue;
      }

      for (let j = 0; j < curSetup.Shots.length; j++) {
        const curShot = curSetup.Shots[j];

        if (!curShot.IsChecked) {
          continue;
        }

        for (let k = 0; k < curShot.LMInfos.length; k++) {
          const lminfo = curShot.LMInfos[k];

          if (lminfo.LMType === lmDrawing) {
            if (lminfo.CurveFit) {
              const curve = JSON.parse(lminfo.CurveFit);
              const traj = ParseCurveFit(curve,offsetX,offsetZ,RotateDeg);

              if(traj === null){
                continue;
              }
              
              const lastPoint = traj[traj.length - 1];
              const lm = lminfo.LMType;
              const xPos = lastPoint[1] * 3;
              const zPos = lastPoint[0];
              
              shotData.push({ Num: curShot.ShotNumber, LMType: lm, x: xPos, z: zPos, curve: JSON.parse(lminfo.CurveFit) });
            } else if (
              lminfo.Measurements &&
              lminfo.Measurements.hasOwnProperty("ShotCarryDispFt") &&
              lminfo.Measurements.hasOwnProperty("ShotCarryYd")
            ) {
              const lm = lminfo.LMType;
              let zPos = lminfo.Measurements["ShotCarryYd"];
              let xPos = lminfo.Measurements["ShotCarryDispFt"];
              let lateralYds = xPos/3;
              let adjustedLateralYds = lateralYds;
              //call new funcion on lastpoints?
              const out = WorkPlottedShotsLikeParseCurv(zPos,lateralYds,offsetX,offsetZ,RotateDeg)
              if (out != null){
                [zPos,adjustedLateralYds]=out;
                const lateralFt = adjustedLateralYds*3;
                shotData.push({ Num: curShot.ShotNumber, LMType: lm, x: lateralFt, z: zPos, curve: null });
              }
            }
          }
        }
      }

      sessionData.push({
        Id: curSetup.Id,
        Color: getSetupColor(curSetup, i).bg,
        Shots: shotData,
      });
    }

    setPlottedShots(sessionData);
  };
  function WorkPlottedShotsLikeParseCurv(x,y,offsetX= 0,offsetZ = 0,rotationAngleDeg = 0){
    if (x==null||y==null) {
      return null;
    }
    const theta = rotationAngleDeg * (Math.PI / 180);
    const X = x;
    const Y = y;
    

      // Apply the offset.
      // For rotation about the Z-axis, the offsets are applied to x and y.
    const preRotX = x + offsetZ;
    const preRotY = y + offsetX;
    

    // Rotate around the Z-axis.
    // Standard formulas:
    //   rotatedX = preRotX*cos(theta) - preRotY*sin(theta)
    //   rotatedY = preRotX*sin(theta) + preRotY*cos(theta)
    const rotatedX = preRotX * Math.cos(theta) - preRotY * Math.sin(theta);
    const rotatedY = preRotX * Math.sin(theta) + preRotY * Math.cos(theta);

    return [rotatedX, rotatedY];


  }
  function ParseCurveFit(data, offsetX = 0, offsetZ = 0, rotationAngleDeg = 0) {
    if (!data) {
      return null;
    }
    
    const xfit = data["XFit"];
    const yfit = data["YFit"];
    const zfit = data["ZFit"];
    const timeInt = data["TimeInterval"];
    
    if (timeInt.length === 0) {
      return null;
    }
    
    // Helper: Evaluate a polynomial at time t
    function evaluatePolynomial(coefficients, t) {
      return coefficients.reduce((sum, coeff, index) => sum + coeff * Math.pow(t, index), 0);
    }
    
    const numPoints = 100;
    const timeStep = (timeInt[1] - timeInt[0]) / (numPoints - 1);
    const timePoints = Array.from({ length: numPoints }, (_, i) => timeInt[0] + i * timeStep);
    
    // Convert degrees to radians, negated for clockwise rotation
    const theta = rotationAngleDeg * (Math.PI / 180);
    
    let motionData = timePoints.map(t => {
      // Evaluate the curves
      const x = evaluatePolynomial(xfit, t);
      const y = evaluatePolynomial(yfit, t);
      const z = evaluatePolynomial(zfit, t);
      
      // Apply the offset.
      // For rotation about the Z-axis, the offsets are applied to x and y.
      const preRotX = x + offsetZ;
      const preRotY = y + offsetX;
      const preRotZ = z; // remains unchanged
      
      // Rotate around the Z-axis.
      // Standard formulas:
      //   rotatedX = preRotX*cos(theta) - preRotY*sin(theta)
      //   rotatedY = preRotX*sin(theta) + preRotY*cos(theta)
      const rotatedX = preRotX * Math.cos(theta) - preRotY * Math.sin(theta);
      const rotatedY = preRotX * Math.sin(theta) + preRotY * Math.cos(theta);
      
      return [rotatedX, rotatedY, preRotZ];
    });
    
    return motionData;
  }
  
  const saveState = (currentScale, currentOrigin) => {
    sessionStorage.setItem('topdown-scale', currentScale);
    sessionStorage.setItem('topdown-origin', JSON.stringify(currentOrigin));
  };

  function DrawDebugLine(context, origin, end){
    context.strokeStyle = 'blue';
    context.lineWidth = 2;

    context.beginPath();

    context.moveTo(origin.x,origin.y);
    context.lineTo(end.x,end.y);

    context.stroke();
  }

  return (
    <canvas
      ref={canvasRef}
      style={{ width: '100%', height: '100%', display: 'block', cursor: 'grab' }}
      title="Shift+Click to add a point"
    />
  );
};

export default TopDown;
